class AuthorBooks extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    const name = this.dataset.authorName;
    const handle = this.dataset.authorHandle;
    const searchUrl = this.dataset.searchUrl;
    const section = this.querySelector('[data-ref="section"]');
    const results = this.querySelector('[data-ref="results"]');
    const existingHandles = this.dataset.existingHandles || '';

    if (!name || !handle || !searchUrl || !section || !results) return;

    const params = new URLSearchParams({
      view: 'author-books',
      type: 'product',
      'options[prefix]': 'last',
      q: `"${name}"`
    });

    try {
      const response = await fetch(`${searchUrl}?${params.toString()}`, {
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentFragment.querySelector('[data-author-book-results]');
      if (!source) throw new Error('Missing author results');

      source.querySelectorAll('[data-author-book-handle]').forEach((item) => {
        const marker = `|${item.dataset.authorBookHandle}|`;
        if (existingHandles.includes(marker)) item.remove();
      });

      if (source.querySelector('[data-author-book-handle]')) {
        results.replaceChildren(...source.childNodes);
        section.hidden = false;
      }
    } catch (error) {}
  }
}

if (!customElements.get('author-books')) {
  customElements.define('author-books', AuthorBooks);
}
